import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import UsersLogin from './Views/Auth/UsersLogin/UsersLogin.js'
import Email from './Views/Auth/ForgetPassword/Email/email.js'
import ConfirmCode from './Views/Auth/ForgetPassword/confirmationCode/confirmationCode.js'
import NewPassword from './Views/Auth/ForgetPassword/resetPassword/resetPassword.js';
import Layout from './Components/DefaultyLayout/defaultLayout.js'
import cookie from 'react-cookies'
import { MyTicket_PATH, MyTicket_LANGUAGE } from './AppConfig';
// import ViewCinema from './Views/Cinema/Cinema/ViewCinema/viewcinema';
import MapPage from './Template/Version_one/Map/googleMap'
import '@progress/kendo-theme-default/dist/all.css';

class App extends Component {
  render() {

    if (cookie.load(MyTicket_LANGUAGE) === undefined) {
      cookie.save(MyTicket_LANGUAGE, JSON.stringify("ar"), { path: MyTicket_PATH })
    }
    if (this.props.lang === 'ar') {
      document.body.style.direction = "rtl";
      document.body.style.textAlign = "right";

    }
    else if (this.props.lang === 'en') {
      document.body.style.direction = "ltr";
      document.body.style.textAlign = "left";
    }
    return (
      <BrowserRouter>
        <Switch >
          <Route path="/MyticketCinema/login" name="Login Page" component={UsersLogin}/>
          <Route exact path="/MyticketCinema/forgetpassword" name="Forget Password" component={Email} />
          <Route exact path="/MyticketCinema/ConfirmCode" name="ConfirmCode" component={ConfirmCode} />
          <Route exact path='/MyticketCinema/newPasswordPage' name="New Password" component={NewPassword} />
          <Route path="/MyticketCinema/" name="Home" component={Layout} />
        </Switch> 
      </BrowserRouter>

    );
  }
}

const mapStateToProps = state => {
  return {
    lang: state.userInfo.language,

  }

}
export default connect(mapStateToProps, null)(App);






